import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import Controls from "../../../controls/Controls";
import { useForm, Form } from "../../../controls/useForm";
import { request } from "../../../../api/Service";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import StatComponent from "../../stat-page/StatComponent";
import "react-toastify/dist/ReactToastify.css";
import { SettingsBackupRestoreOutlined } from "@material-ui/icons";
import { connect } from "react-redux";
const initialFValues = {
  salesPrice: 0,
  costPrice: 0,
  productName: "",
  locationId: 0,
  quantity: 0,
  sku: "",
  storageTankId: 0,
};

function AddInventoryForm(props) {
  const {
    addOrEdit,
    addInventory,
    recordForEdit,
    products,
    locations,
    storageTanks,
    allProducts,
  } = props;
  const [productName, setProductName] = useState("");
  const [productDescription, setProductDescription] = useState("");
  const [imageId, setImageId] = useState("");
  const [salesPrice, setSalesPrice] = useState("");
  const [costPrice, setCostPrice] = useState("");
  const [sku, setSku] = useState("");
  const [productId, setProductId] = useState("");
  const [location, setLocation] = useState(0);
  const [locationId, setLocationId] = useState(0);
  const [storageTank, setStorageTank] = useState("");
  const [storageTankId, setStorageTankId] = useState(0);

  const [filteredTanks, setFilteredTanks] = useState([]);

  //   {
  //   "costPrice": 0,
  //   "storageTankId": 0,
  //   "locationId": 0,
  //   "quantity": 0,
  //   "sku": "string"
  // }

  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    if ("costPrice" in fieldValues)
      temp.costPrice =
        fieldValues.costPrice > 0 ? "" : "This field is required.";
    if ("storageTankId" in fieldValues)
      temp.storageTankId =
        fieldValues.storageTankId > 0 ? "" : "This field is required.";
    if ("locationId" in fieldValues)
      temp.locationId =
        fieldValues.locationId > 0 ? "" : "This field is required.";
    if ("quantity" in fieldValues)
      temp.quantity = fieldValues.quantity ? "" : "Quantity is required.";
    if ("sku" in fieldValues)
      temp.sku = fieldValues.sku > 0 ? "" : "Product SKU Is Needed";
    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };
  const handleInputSalesChange = (e, v) => {
    if (e.target == null) {
      setSalesPrice(v);
    } else {
      setSalesPrice(e.target.value);
    }
  };
  const handleInputCostChange = (e, v) => {
    if (e.target == null) {
      setCostPrice(v);
    } else {
      setCostPrice(e.target.value);
    }
  };
  var locationIdValue = 0;
  const handleInputLocation = (e, v) => {
    localStorage.setItem("locationIdValue", v?.id);
    localStorage.setItem("skuValue", "");
    setSku("");
    setLocation(v?.label);
    setLocationId(v?.id);
    get_product();
  };
  const handleInputProductNameChange = (e, v) => {
    if (e.target == null) {
      setProductName(v);
    } else {
      setProductName(e.target.value);
    }
  };
  const handleInputProductDescriptionChange = (e, v) => {
    if (e.target == null) {
      setProductDescription(v);
    } else {
      setProductDescription(e.target.value);
    }
  };
  const handleInputSkuChange = (e, v) => {
    if (e.target == null) {
      setSku(v?.id);
      setProductId(v?.id);
    } else {
      console.log("SKU Value", v.id, e.target.value);
      setSku(v?.id);
      setProductId(v?.id);
      localStorage.setItem("skuValue", v?.id);
      localStorage.setItem("skuLabel", v?.label);
      if (v?.id > 3) {
        get_product(v?.id);
        setSku(localStorage.getItem("skuLabel"));
        setProductId(v?.id);
      }
    }
  };

  var get_product = () => {
    console.log(
      `get-web-product-by-sku-location?sku=${sku}&locationId=${localStorage.getItem(
        "locationIdValue"
      )}`
    );

    if (
      localStorage.getItem("locationIdValue") > 0 &&
      localStorage.getItem("skuValue") != ""
    ) {
      console.log(
        `get-web-product-by-sku-location?sku=${localStorage.getItem(
          "skuValue"
        )}&locationId=${localStorage.getItem("locationIdValue")}`
      );
      request(
        "get",
        {},
        `get-web-product-by-sku-location?sku=${localStorage.getItem(
          "skuValue"
        )}&locationId=${localStorage.getItem("locationIdValue")}`
      ).then((data) => {
        if (data.productName != null) {
          handleInputSalesChange("", data.salesPrice);
          handleInputProductNameChange("", data.productName);
          handleInputProductDescriptionChange("", data.productDescription);
          // handleInputSkuChange('', data.sku);
          handleInputCostChange("", data.costPrice);
        } else {
          handleInputSalesChange("", "");
          handleInputProductNameChange("", "");
          handleInputProductDescriptionChange("", "");
          handleInputCostChange("", "");
        }
      });
    }
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, validate, get_product);
  const handleSubmit = (e) => {
    e.preventDefault();
    // if (productName == '') {
    //   toast.error('Product Name is Required!');
    // }
    if (productDescription == "") {
      toast.error("Product Description is Required");
    } else if (values.costPrice == 0) {
      toast.error("Cost Price is Required");
    } else if (location == 0) {
      toast.error("Location is Required");
    } else if (sku == "") {
      toast.error("SKU is Required");
    } else {
      var record = {
        costPrice: values.costPrice,
        storageTankId,
        locationId: localStorage.getItem("locationIdValue"),
        quantity: values.quantity,
        sku: localStorage.getItem("skuValue"),
      };

      console.log("User Record", record);
      addOrEdit(record, resetForm);
    }
  };

  // Sales Price Removed from Add Item To Inventory

  //  else if (salesPrice == 0) {
  //     toast.error("Sales Price is Required");
  //   }

  useEffect(() => {
    if (recordForEdit !== null)
      setValues({
        ...recordForEdit,
      });
  }, [recordForEdit]);

  // Added
  function reformatDrop(values) {
    var newArray = [];
    for (var i = 0; i < values.length; i++) {
      newArray.push({
        label: values[i].title,
        id: values[i].id,
      });
    }
    return newArray;
  }

  const [holdBtn, setHoldBtn] = useState(true);

  useEffect(() => {
    console.log("Inventory Details", {
      productDescription,
      quantity: values.quantity,
      costPrice: values.costPrice,
      locationId: localStorage.getItem("locationIdValue"),
      sku: localStorage.getItem("skuValue"),
    });
    if (
      productDescription &&
      values.quantity &&
      values.costPrice &&
      location &&
      sku
    ) {
      setHoldBtn(false);
    } else {
      setHoldBtn(true);
    }
  }, [values, costPrice, location, sku, productDescription]);

  // Filter for storage Tanks
  function reformatDropStorage(values) {
    var newArray = [];
    for (var i = 0; i < values.length; i++) {
      newArray.push({
        label: values[i].tankShortName,
        id: values[i].id,
      });
    }
    return newArray;
  }

  useEffect(() => {
    if (locationId) {
      const filtered = storageTanks.filter(
        (tank) => tank.locationId === locationId
      );
      console.log("Filtered Locations-",filtered);
      setFilteredTanks(filtered);
    } else {
      setFilteredTanks([]); // Reset if no location is selected
    }
  }, [locationId, storageTanks]);

  const handleStorageTankChange = (e, v) => {
    setStorageTank(v?.label);
    setStorageTankId(v?.id);
  };

  // Products
  function reformatDropProducts(values) {
    var newArray = [];
    for (var i = 0; i < values.length; i++) {
      newArray.push({
        label: values[i].title,
        id: values[i].sku,
      });
    }
    return newArray;
  }

  return (
    <Form onSubmit={handleSubmit}>
      <ToastContainer />
      <Grid container>
        <Grid item xs={6}>
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            name="locationId"
            value={location || ""}
            options={reformatDrop(locations)}
            error={errors.locationId}
            onChange={handleInputLocation}
            className="w-100"
            renderInput={(params) => (
              <TextField {...params} label="Select Locations" />
            )}
          />
          <Controls.Input
            name="costPrice"
            label="Cost Price"
            value={values.costPrice}
            onChange={handleInputChange}
            error={errors.costPrice}
          />
          <Controls.Input
            label="Quantity"
            name="quantity"
            value={values.quantity || ""}
            onChange={handleInputChange}
            error={errors.quantity}
          />
        </Grid>
        <Grid item xs={6}>
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            name="storageTankId"
            value={storageTank || ""}
            options={reformatDropStorage(filteredTanks)}
            error={errors.storageTankId}
            onChange={handleStorageTankChange}
            className="w-100"
            renderInput={(params) => (
              <TextField {...params} label="Select Storage Tank" />
            )}
          />

          <Autocomplete
            disablePortal
            id="combo-box-demo"
            name="sku"
            value={sku || ""}
            options={reformatDropProducts(products)}
            error={errors.sku}
            onChange={handleInputSkuChange}
            className="w-100"
            renderInput={(params) => <TextField {...params} label="Product" />}
          />

          {/* <Controls.Input
            name="salesPrice"
            label="Sales Price"
            value={salesPrice}
            onChange={handleInputSalesChange}
            error={errors.salesPrice}
          /> */}
          <Controls.Input
            name="productDescription"
            label="Product Description"
            value={productDescription || ""}
            onChange={handleInputProductDescriptionChange}
            error={errors.productDescription}
          />
          <div>
            <Controls.Button disabled={holdBtn} type="submit" text="Submit" />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
}

const mapStateToProps = (state) => {
  return {
    allProducts: state.productReducer.products,
  };
};

export default connect(mapStateToProps)(AddInventoryForm);
